import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks, singleEmailValidation } from "@/services/misc/functions/ValidationFunctions";

export class CreateUserForm {
  public username: string = '';
  public email: string = '';
  public password: string = '';
  public passwordConf: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public birthDate: string = '';
  public firstDay: string = '';
  public role: string = '';
  public department: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    username: [
      (v: string) => !!v || 'Username is required',
      (v: string) => v.length <= 24 || 'Username can be at most 24 characters',
      (v: string) => v.length >= 6 || 'Username has to be at least 6 characters',
      (v: string) => !v || /^[a-zA-Z0-9.\-_]+$/.test(v) || 'Username must contain only letters and numbers and (. - _)',
    ],
    email: [
      (v: string) => !!v || 'Email is required',
      ...singleEmailValidation(),
    ],
    password: [
      (v: string) => !!v || 'Password is required',
      ...PasswordValidationCallbacks,
    ],
    name: [
      (v: string) => !!v || 'Name is required',
      (v: string) => v.length >= 2 || 'Name must be at least 2 characters',
    ],
    birthDate: [
      (v: string) => !!v || 'Birth Date is required',
    ],
    firstDay: [
      (v: string) => !!v || 'First Date is required',
    ],
    role: [
      (v: string) => !!v || 'You have to select a role',
    ],
    department: [
      (v: string) => !!v || 'You have to select a department',
    ],
  };
}
